var $fe5998f640a79fd2$exports = {};
$fe5998f640a79fd2$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farbw\xe4hler`,
    "colorSwatch": `Farbfeld`,
    "transparent": `transparent`,
    "twoDimensionalSlider": `2D-Schieberegler`
};


export {$fe5998f640a79fd2$exports as default};
//# sourceMappingURL=de-DE.module.js.map
